<template>
  <div class="layout">
    <div class="layout-content">
      <router-view />
    </div>
    <van-tabbar v-model="active" route active-color="#2F88FF" inactive-color="#A0A4AE">
      <van-tabbar-item icon="wap-home-o" to="/dashboard">工作台</van-tabbar-item>
      <van-tabbar-item icon="orders-o" to="/bill">话单</van-tabbar-item>
      <van-tabbar-item icon="friends-o" to="/customer-resource">客资</van-tabbar-item>
      <van-tabbar-item icon="underway-o" to="/oa-punch">考勤</van-tabbar-item>
      <van-tabbar-item icon="contact" to="/mine">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'Layout',
  data() { return { active: 0 } }
}
</script>

<style scoped>
.layout { height: 100%; display: flex; flex-direction: column; }
.layout-content { flex: 1; overflow-y: auto; -webkit-overflow-scrolling: touch; padding-bottom: 8px; }
</style>
